import { ca } from '@cian/analytics';
import { getProduct, getPageNumber } from '../../utils/trackings';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';
import { convertToFavoriteEntityType } from '../../utils/favoriteEntity';
import { IFavoriteEntity } from '../../types/results';
import { EEntityType } from '../../types/filters';

export function trackPhoneButtonClick(
  pageData: IPageState,
  user: TUser,
  entityId: number,
  favoriteEntities: IFavoriteEntity[],
  total: number,
) {
  const currentEntity = favoriteEntities.find(({ entityId: id }) => id === entityId);
  const product = getProduct(entityId, favoriteEntities);

  ca('eventEbc', {
    category: 'Phones',
    action: 'Open_favorites',
    label: getCustomUrl(currentEntity),
    name: 'oldevent',
    user: {
      abGroup: pageData.abGroup,
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, product.position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
    products: [product],
  });
}

export function getCustomUrl(favoriteEntity?: IFavoriteEntity): string | undefined {
  if (favoriteEntity) {
    const { dealType, entityType, entityId } = favoriteEntity;

    return `/${dealType}/${convertToFavoriteEntityType((entityType as unknown) as EEntityType)}/${entityId}`;
  } else {
    return undefined;
  }
}
